export default from './not-found';



// WEBPACK FOOTER //
// ./app/components/not-found/index.js